import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ViewerRouteParamsService {

  private readonly router: Router = inject(Router);

  public get viewId(): string | null {
    return this.decodeParam('view_id');
  }

  public get amenities(): string | null {
    return this.decodeParam('amenities');
  }

  public get relatedPreview(): string | null {
    return this.decodeParam('related_preview');
  }

  public get hasViewId(): boolean {
    return this.queryParamMap.has('view_id') && !!this.viewId;
  }

  private get queryParamMap() {
    return this.router.parseUrl(this.router.url).queryParamMap;
  }

  private decodeParam(key: string): string | null {
    const value = this.queryParamMap.get(key);
    if (!value) return null;

    try {
      return atob(value);
    } catch {
      return null;
    }
  }

}
